<template>
  <v-app-bar v-if="status" app style="height: 64px" elevation="0" color="white" class="half-1px-line-bottom">
    <v-row no-gutters align="center" class="pl-5 pr-8">
      <v-app-bar-nav-icon @click="toggleNavBar" aria-label="topbar-navigation-btn"></v-app-bar-nav-icon>
      <v-img class="mx-2" max-width="200" :src="require('@/assets/images/logo.png')" contain alt="topbar-logo"></v-img>
      <v-spacer></v-spacer>
      <v-btn v-if="can_approve" variant="outlined" rounded class="approval-btn-text text-none" @click="store.dispatch('initChangeApprovalDialog', { mode: 'admin' })">
        {{ t('$vuetify.__Approval.change_approval') }}
      </v-btn>
      <!-- <v-avatar class="approval-alert-icon" color="#e63821" size="20">
      <v-icon size="16" color="white">mdi-exclamation-thick</v-icon>
    </v-avatar> -->
      <v-menu ref="menu" offset-y :close-on-content-click="false" :close-on-click="true" content-class="popup-menu">
        <template v-slot:activator="{ props }">
          <v-avatar size="36" color="#464646" class="ml-6" v-bind="props"><v-icon color="#ffffff">mdi-account</v-icon></v-avatar>
        </template>
        <v-card class="pa-3 user-menu">
          <v-row no-gutters justify="center">
            <v-col>
              <v-row no-gutters justify="center">
                <v-avatar color="#464646" size="56" class="mt-4 mb-1"><v-icon color="white" size="36">mdi-account</v-icon></v-avatar>
              </v-row>
              <v-row no-gutters justify="center" class="user-menu-name pa-2">{{ user_info.username }}</v-row>
              <v-row no-gutters justify="center" class="user-menu-role">{{ user_info.role }}</v-row>
              <v-row no-gutters justify="center" class="py-4">
                <v-btn variant="outlined" rounded class="text-none user-menu-logout" @click="store.dispatch('logout')"><v-icon>mdi-logout</v-icon>Logout</v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-menu>
    </v-row>
  </v-app-bar>
</template>

<script setup>
import { useLocale } from 'vuetify'
const { t } = useLocale()
import { useStore } from 'vuex'
const store = useStore()

import { computed } from 'vue'

const status = computed(() => store.state.auth.status)
const user_info = computed(() => store.state.auth.user_info)
const device_id = computed(() => store.state.auth.selected_device)
const can_approve = computed(() => {
  if (store.state.auth.privileges?.privileges) {
    const privileges = store.state.auth.privileges?.privileges.device[device_id.value]
    const can_approve = privileges?.includes('Device.PR.Review') || privileges?.includes('Device.All')
    return can_approve
  } else return false
})

const toggleNavBar = () => {
  store.commit('SET_LEFTBAR_VISIBILITY')
  store.commit('SET_RIGHT_BAR_VISIBILITY', 'toggle')
}
</script>

<style scope>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@600&display=swap');
.v-app-bar-title__placeholder {
  font-family: 'Nunito Sans', sans-serif;
}

.approval-btn-text {
  color: #211f20 !important;
  font-family: Open Sans !important;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 24px;
}

.approval-alert-icon {
  top: -17px;
  left: -17px;
  margin-right: -20px;
}

.user-menu {
  background: #ffffff;
  box-shadow:
    0px 2px 2px rgba(0, 0, 0, 0.14),
    0px 3px 1px rgba(0, 0, 0, 0.12),
    0px 1px 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.user-menu-name {
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  color: #1b1b1b;
}

.user-menu-role {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #828282;
}

.user-menu-logout {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #1b1b1b;
}
</style>
